import React, { useState } from 'react';
import { Radio } from '@design-system-coopeuch/web';
import PropTypes from 'prop-types';
import { WrapperPreguntaEncuestaRadioButton } from './styles';
import { properties } from '../../../../utils/properties';

const PreguntaEncuestaRadiobutton = ({ setHabilitarInput, setCalificacionRadioButton }) => {
  const [listaRadio, setListaRadio] = useState(properties.encuestaAbandono.pregunta1Opciones);
  
  const handleChange = (opcion) => {
    let items = [...listaRadio];
    items = items.map((item) => {
      item.estado = false;
      return item;
    });
    const item = { ...items[opcion.orden-1] };
    item.estado = true;
    items[opcion.orden-1] = item;
    setListaRadio(items);
    setCalificacionRadioButton(opcion.indice);
    setHabilitarInput(opcion.abreInput);
  };

  return (
    <WrapperPreguntaEncuestaRadioButton>
      <div className="label-radio">
        {listaRadio.map((opcion) => {
          return (
            <Radio
              checked={opcion.estado}
              disabled={false}
              label={opcion.descripcion}
              name={opcion.descripcion.replace(/ /g, "")}
              onChange={() => handleChange(opcion)}
            />
          );
        })}
      </div>
    </WrapperPreguntaEncuestaRadioButton>
  );
};

PreguntaEncuestaRadiobutton.propTypes = {
  setHabilitarInput: PropTypes.func.isRequired,
  setCalificacionRadioButton: PropTypes.func.isRequired,

};

export default PreguntaEncuestaRadiobutton;
